import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ChartsPageDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getUserChartId(sharedId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/charts_page/get_user_chart_id${sharedId}`,
    );
  }

  getChartsMeta(params: string): Observable<any> {
    return this.http.get(`${this.apiEP}/charts_page/get_charts_meta?${params}`);
  }

  getIndustryChartsMeta(params: string): Observable<any> {
    return this.http.get(`${this.apiEP}/api/get_default_chart_data?${params}`);
  }

  getIndustryQuickList(industryName: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_peer_groups_quick_list?industry_name=${industryName}`,
    );
  }

  getSuggestedLineItems(industryName: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_suggested_industry_lines_for_charts?industry_name=${industryName}`,
    );
  }

  deleteChart(chartId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/charts_page/delete_charts?chart_id=${chartId}`,
    );
  }

  //check for charts
  getWatchlists(): Observable<any> {
    return this.http
      .get(`${this.apiEP}/comps/get_user_watchlist_for_comps/`)
      .pipe(catchError((error) => of(error)));
  }

  getRecentlyVisitedCompanies(): Observable<any> {
    return this.http
      .get(`${this.apiEP}/comps/get_recently_visited_active_companies`)
      .pipe(catchError((error) => of(error)));
  }

  updateCharts(data) {
    return this.http.post(`${this.apiEP}/charts_page/update_charts`, data);
  }

  getStdLineItems(reqObj): Observable<any> {
    reqObj["show_val_ratio"] = true;
    return this.http.post(`${this.apiEP}/comps/get_std_line_items`, reqObj);
  }

  getAvailableCurrencies(): Observable<any> {
    return this.http.get(`${this.apiEP}/api/get_available_currencies`);
  }

  getPeriods() {
    return this.http.get(`${this.apiEP}/comps/get_period?period_range=charts`);
  }

  saveNewChart(reqObj): Observable<any> {
    return this.http.post(
      `${this.apiEP}/charts_page/create_user_chart`,
      reqObj,
    );
  }

  //share chart api calls
  getUserSuggestions(searchQuery) {
    return this.http.get(
      `${this.apiEP}/watcher/get_user_suggestions/?q=${searchQuery}&internal_user_filter=true`,
    );
  }

  shareCharts(chartId: string, emailId: string): Observable<any> {
    return this.http.get(
      `${
        this.apiEP
      }/charts_page/share_charts?recipient_email=${encodeURIComponent(
        emailId,
      )}&chart_id=${chartId}`,
    );
  }

  getSharedChartsHistory(chartId: string) {
    return this.http.get(
      `${this.apiEP}/charts_page/shared_charts_history/?chart_id=${chartId}`,
    );
  }

  getAdditionalInfo(ticker) {
    return this.http.get(
      `${this.apiEP}/charts_page/get_ticker_rel_info?${ticker}`,
    );
  }

  getCompanyPeers(
    tickers: Array<string>,
    sliIds: Array<number>,
    limit?: number,
  ): Observable<any> {
    if (sliIds && sliIds.length) {
      return this.http
        .get(
          `${this.apiEP}/charts_page/get_company_peers?ticker=${tickers.join(
            "&ticker=",
          )}&uniquesliid=${sliIds.join("&uniquesliid=")}&limit=3`,
        )
        .pipe(catchError((error) => of(error)));
    }
    return this.http
      .get(
        `${this.apiEP}/charts_page/get_company_peers?ticker=${tickers.join(
          "&ticker=",
        )}&limit=${limit ? limit : 10}`,
      )
      .pipe(catchError((error) => of(error)));
  }

  getNMVSliMapping(ticker: string, nmvLine: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_nmv_sli_mapping/?ticker=${ticker}&cut=NMV&dapparameterid=${nmvLine}&primary_sli=true`,
    );
  }
}
